import { TFunction } from 'i18next'
import { isNil, isNumber } from 'lodash'

export const emptyText = (t: TFunction) => t('text.empty', { ns: 'common' })

export const optionalText =
    (t: TFunction) =>
    (i?: string | number): string =>
        !isNil(i) ? (isNumber(i) ? i.toString() : i) : emptyText(t)

export const joinPipe = (items: string[]): string => items.join(' | ')

export const thinSpace = '\u2009'
